import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "./axios";

const fetchCategories = async () => {
  const response = await apiInstance.post("/Customer/GetCategory", {
    CategoryId: 0,
    CategoryType: "category",
  });
  return response.data;
};

const fetchCollections = async () => {
  const response = await apiInstance.post("/Customer/GetCategory", {
    CategoryId: 0,
    CategoryType: "collection",
  });
  return response.data;
};

const useCategoriesCollections = () => {
  const {
    data: categoryData,
    error: categoryError,
    isLoading: categoryLoading,
  } = useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategories,
    staleTime: Infinity, // Cache it forever
    cacheTime: Infinity, // Store it indefinitely
  });

  const {
    data: collectionData,
    error: collectionError,
    isLoading: collectionLoading,
  } = useQuery({
    queryKey: ["collections"],
    queryFn: fetchCollections,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return {
    categoryData,
    collectionData,
    loading: categoryLoading || collectionLoading,
    error: categoryError || collectionError,
  };
};

export default useCategoriesCollections;
